module.exports = __webpack_public_path__ + "img/xiao3.8b316b46.png";